import { observer } from 'mobx-react-lite';

import { IcCloseIcon, IcView16Icon } from '@gem/icons';
import { Button, IconButton } from '@gem/ui-kit';

import styles from './styles.m.css';

const Header = ({ presenter }) => {
  return (
    <div className={styles.container}>
      {presenter.isStreamStarted ? (
        <>
          <div className={styles.live}>LIVE</div>
          <Button
            onClick={presenter.toggleViewers}
            size="0"
            rounding={1}
            theme={presenter.isShowViewers ? 13 : 'fixed-color'}
            Icon={IcView16Icon}
            className={styles.viewers}
          >
            {presenter.viewersLiveCount}
          </Button>
        </>
      ) : (
        <IconButton
          className={styles.close}
          Icon={IcCloseIcon}
          onClick={presenter.onClose}
          size="big"
          iconSize="medium"
          theme="11"
        />
      )}
    </div>
  );
};

export default observer(Header);
